<template>
  <div>
    <NumberFormGroup
        :value="value.limit"
        name="limit"
        label="Limit"
        :error="(errors.limit || [])[0]"
        help-text="The number of items to display."
        @input="emit('limit', $event)"
    />
  </div>
</template>

<script>
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'

export default {
  components: {NumberFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      shared: store
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
